export enum SidebarPanelMode {
  Talks = 'talks',
  Calendar = 'Calendar',
  Spaces = 'spaces',
  Space = 'space',
  None = 'none',
}
